import CodeMirror from 'codemirror';
import { ICustomProperty, IModelField, IModelEnumField } from '../../index.d';
import { getPrevEffectiveToken, hasTokenIncludes } from '../../utils/codemirror';
import { matchFqnPath, mathModelField } from '../../../utils/fqn';


export function isEnumOrBooleanExpression({ editor, pos, customProperties, fqn, models }: {
  editor: CodeMirror.Editor,
  pos: CodeMirror.Position,
  customProperties: ICustomProperty[],
  fqn?: IModelField,
  models?: IModelField[]
}) {

  const currentToken = editor.getTokenAt(pos);

  try {
    const prev1Token = getPrevEffectiveToken(editor, currentToken)!;

    if (!hasTokenIncludes(prev1Token, ['operator'])) {
      return false;
    }

    let isMultiple = false;
    if (prev1Token.string === '==' || prev1Token.string === '!=') {
      isMultiple = false;
    } else if (
      hasTokenIncludes(prev1Token, ['IN']) ||
      hasTokenIncludes(prev1Token, ['NOT-IN'])
    ) {
      isMultiple = true;
    } else {
      return false;
    }

    const prev2Token = getPrevEffectiveToken(editor, prev1Token)!;
    // 如果为自定义属性
    if (hasTokenIncludes(prev2Token, ['custom-property-id'])) {
      const customPropertyId = Number(prev2Token.string.replace(/[\{\}]/g, ''));
      const customProperty = customProperties.find(item => item.id === customPropertyId);
      if (customProperty) {
        if (customProperty.dataType === 'Enum' || customProperty.dataType === 'Boolean') {
          return {
            isMultiple,
            options: (customProperty.options || []).map(item => {
              return { name: item.name, value: JSON.stringify(item.value) };
            })
          };
        }
      }
    }

    if (fqn && hasTokenIncludes(prev2Token, ['fqn', 'property'])) {
      let fqnPathComplete = false;
      const fqnPathTokens: CodeMirror.Token[] = [prev2Token];
      while (!fqnPathComplete) {
        const prevToken = editor.getTokenAt({ line: fqnPathTokens[0].state.line, ch: fqnPathTokens[0].start });
        if (hasTokenIncludes(prevToken, ['fqn', 'property']) || hasTokenIncludes(prevToken, ['dot'])) {
          fqnPathTokens.unshift(prevToken);
          if (hasTokenIncludes(prevToken, ['root'])) {
            fqnPathComplete = true;
          }
        } else {
          return false;
        }
      }
      const fqnPath = fqnPathTokens.map(token => token.string).join('');
      const valueInFqnPath = matchFqnPath(fqn, fqnPath);
      if (valueInFqnPath) {
        if (valueInFqnPath.type === 'Enum') {
          return {
            isMultiple,
            options: (valueInFqnPath as IModelEnumField)
              .options.map((v: string) => ({ name: String(v), value: JSON.stringify(v) }))
          };
        } else if (valueInFqnPath.type === 'Boolean') {
          return { isMultiple, options: [{ name: 'True', value: 'true' }, { name: 'False', value: 'false' }] };
        }
      }
    }


    if (models && models.length) {
      if (hasTokenIncludes(prev2Token, ['bracket']) && prev2Token.string === ')') {
        const prev3Token = getPrevEffectiveToken(editor, prev2Token)!;
        if (hasTokenIncludes(prev3Token, ['model-path'])) {
          const prev4Token = getPrevEffectiveToken(editor, prev3Token)!;
          if (hasTokenIncludes(prev4Token, ['bracket']) && prev4Token.string === '(') {
            const prev5Token = getPrevEffectiveToken(editor, prev4Token)!;
            if (hasTokenIncludes(prev5Token, ['model'])) {
              const modelFqn = prev5Token.string;
              const modelPath = prev3Token.string;
              const model = models.find(item => item.fqn === modelFqn);
              if (model) {
                const field = mathModelField(model, modelPath);
                if (field) {
                  if (field.type === 'Enum') {
                    return {
                      isMultiple,
                      options: (field as IModelEnumField).options
                        .map((v: string) => ({ name: String(v), value: JSON.stringify(v) }))
                    };
                  } else if (field.type === 'Boolean') {
                    return { isMultiple, options: [{ name: 'True', value: 'true' }, { name: 'False', value: 'false' }] };
                  }
                }
              }
            }
          }

        }

      }
    }

    return false;
  }
  catch (err) {
    return false;
  }
}

